export default __webpack_public_path__ + "static/media/recipes.06bdeb0e.svg";